export const getURLSearchParam = <T extends string>(param: T) => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(param);
};

export const setURLSearchParam = <T extends string>(param: T, value: string | null) => {
    const searchParams = new URLSearchParams(window.location.search);
    if (value === null || value === undefined || value === "") {
        searchParams.delete(param);
    } else {
        searchParams.set(param, value);
    }

    const url = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", url);
};
